export default "__VITE_ASSET__fGZLqD_s__"